/**
 * @type {Object}
 */
export default {
  FIVE_MIN: 5 * 60 * 1000
};
